import administrationBlockIcon from '../../assets/icons/blue/administration_block.svg';
import teamActiveIcon from '../../assets/icons/blue/team_blue.svg';
import teamIcon from '../../assets/icons/grey/team_grey.svg';
import suppliersActiveIcon from '../../assets/icons/blue/suppliers_blue.svg';
import suppliersIcon from '../../assets/icons/grey/suppliers_grey.svg';
import employeesIcon from '../../assets/icons/grey/Employees_grey.svg';
import employeesActiveIcon from '../../assets/icons/blue/Employees_blue.svg';
import articlesActiveIcon from '../../assets/icons/blue/articles_blue.svg';
import articlesIcon from '../../assets/icons/grey/articles_grey.svg';
import administrationIcon from '../../assets/icons/grey/Administration_grey.svg';
import administrationActiveIcon from '../../assets/icons/blue/Administration_blue.svg';
import caseTemplateActiveIcon from '../../assets/icons/blue/case_template_blue.svg';
import caseTemplateIcon from '../../assets/icons/grey/case_template_grey.svg';
import logIcon from '../../assets/icons/grey/log_grey.svg';
import logActiveIcon from '../../assets/icons/blue/log_blue.svg';
import coreDataIcon from '../../assets/icons/grey/basedata_grey.svg';
import coreDataActiveIcon from '../../assets/icons/blue/basedata_blue.svg';
import goalIcon from '../../assets/icons/grey/goal_grey.svg';
import goalActiveIcon from '../../assets/icons/blue/goal_blue.svg';

import { ROLES } from '../../../../../constants';

export default [
  {
    name: 'Master Data',
    icon: administrationBlockIcon,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    items: [
      {
        name: 'Company Structure',
        titleKey: 'Company Structure',
        route: '/gmva/company-structure',
        icon: teamIcon,
        activeIcon: teamActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
      {
        name: 'Contact Details',
        titleKey: 'Contact Details',
        route: '/gmva/contact-details',
        icon: employeesIcon,
        activeIcon: employeesActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
      },
      {
        name: 'Suppliers',
        titleKey: 'Suppliers',
        route: '/gmva/suppliers',
        icon: suppliersIcon,
        activeIcon: suppliersActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
      },
      {
        name: 'teams',
        titleKey: 'teams',
        icon: teamIcon,
        activeIcon: teamActiveIcon,
        isActive: false,
        route: '/gmva/teams',
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
    ],
  },
  {
    name: 'Personnel Planning',
    icon: administrationBlockIcon,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    items: [
      {
        name: 'Shift Plans',
        titleKey: 'Shift Plans',
        route: '/gmva/shift-plans',
        icon: articlesIcon,
        activeIcon: articlesActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
        clickable: true,
      },
      {
        name: 'Shift Positions',
        titleKey: 'Shift Positions',
        route: '/gmva/shift-positions',
        icon: teamIcon,
        activeIcon: teamActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
      {
        name: 'shift-template',
        titleKey: 'Shift Template',
        route: '/gmva/shift-template',
        icon: caseTemplateIcon,
        activeIcon: caseTemplateActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
    ],
  },
  {
    name: 'Operations',
    icon: administrationBlockIcon,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    items: [
      {
        name: 'Shift Log',
        titleKey: 'Shift Log',
        route: '/gmva/shift-log',
        icon: logIcon,
        activeIcon: logActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
      },
    ],
  },
  {
    name: 'Reporting',
    icon: administrationBlockIcon,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    items: [
      {
        name: "Zusammenfassung BTB",
        titleKey: 'Zusammenfassung BTB',
        route: '/gmva/cover-sheet',
        icon: goalIcon,
        activeIcon: goalActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      },
      {
        name: "Deckblatt",
        titleKey: 'Deckblatt',
        route: '/gmva/deckblatt',
        icon: goalIcon,
        activeIcon: goalActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      },
      {
        name: "Anlageninput",
        titleKey: 'Anlageninput',
        route: '/gmva/plant-input',
        icon: goalIcon,
        activeIcon: goalActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      },
      {
        name: "Anlageninput graphisch",
        titleKey: 'Anlageninput graphisch',
        route: '/gmva/plant-input-graphically',
        icon: goalIcon,
        activeIcon: goalActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      },
      {
        name: "Anlageninput kumuliert",
        titleKey: 'Anlageninput kumuliert',
        route: '/gmva/cumulation-daily-quantity',
        icon: goalIcon,
        activeIcon: goalActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      },
      {
        name: "Anlagenoutput",
        titleKey: 'Anlagenoutput',
        route: '/gmva/plant-output',
        icon: goalIcon,
        activeIcon: goalActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      },
      // {
      //   name: 'Planned Values',
      //   titleKey: 'Planned Values',
      //   route: '/avg/planned-values',
      //   icon: goalIcon,
      //   activeIcon: goalActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'Fabric Data',
      //   titleKey: 'Fabric Data',
      //   route: '/avg/fabric-data',
      //   icon: articlesIcon,
      //   activeIcon: articlesActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'Year',
      //   titleKey: 'Years',
      //   route: '/avg/year',
      //   icon: calendarIcon,
      //   activeIcon: calendarActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'Calendar',
      //   titleKey: 'Calendar',
      //   route: '/avg/calendar',
      //   icon: calendarIcon,
      //   activeIcon: calendarActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'Metrics',
      //   titleKey: 'Metrics',
      //   route: '/avg/metrics',
      //   icon: metricsIcon,
      //   activeIcon: metricsActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'RMVA',
      //   titleKey: 'RMVA',
      //   route: '/avg/RMVA',
      //   icon: tableIcon,
      //   activeIcon: tableActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'TRAS',
      //   titleKey: 'TRAS',
      //   route: '/avg/TRAS',
      //   icon: tableIcon,
      //   activeIcon: tableActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'Energiewerte',
      //   titleKey: 'Energiewerte',
      //   route: '/avg/energie-wate',
      //   icon: calendarIcon,
      //   activeIcon: calendarActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'Monthly values',
      //   titleKey: 'Monthly values',
      //   route: '/avg/monthly-values',
      //   icon: tableIcon,
      //   activeIcon: tableActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
      // {
      //   name: 'Log Book',
      //   titleKey: 'Log Book',
      //   route: '/avg/log-book',
      //   icon: calendarIcon,
      //   activeIcon: calendarActiveIcon,
      //   isActive: false,
      //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
      // },
    ],
  },
  {
    name: 'Administration',
    icon: administrationBlockIcon,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    items: [
      {
        name: 'users',
        titleKey: 'Employee',
        route: '/users',
        icon: employeesIcon,
        activeIcon: employeesActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
      {
        name: 'settings',
        titleKey: 'settings',
        icon: administrationIcon,
        activeIcon: administrationActiveIcon,
        isCollapsed: false,
        isActive: false,
        roles: '*',
        route: '/system',
      },
      {
        name: 'User Activity Log',
        titleKey: 'User Activity Log',
        route: '/gmva/user-activity-log',
        icon: coreDataIcon,
        activeIcon: coreDataActiveIcon,
        isActive: false,
        roles: '*',
      },
    ],
  },
];
